export const arrowSingleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z"></path>
  </svg>
);
export const eyeOffLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968ZM5.9356 7.3497C4.60673 8.56015 3.6378 10.1672 3.22278 12.0002C4.14022 16.0521 7.7646 19.0002 12.0003 19.0002C13.5997 19.0002 15.112 18.5798 16.4243 17.8384L14.396 15.8101C13.7023 16.2472 12.8808 16.5002 12.0003 16.5002C9.51498 16.5002 7.50026 14.4854 7.50026 12.0002C7.50026 11.1196 7.75317 10.2981 8.19031 9.60442L5.9356 7.3497ZM12.9139 14.328L9.67246 11.0866C9.5613 11.3696 9.50026 11.6777 9.50026 12.0002C9.50026 13.3809 10.6196 14.5002 12.0003 14.5002C12.3227 14.5002 12.6309 14.4391 12.9139 14.328ZM20.8068 16.5925L19.376 15.1617C20.0319 14.2268 20.5154 13.1586 20.7777 12.0002C19.8603 7.94818 16.2359 5.00016 12.0003 5.00016C11.1544 5.00016 10.3329 5.11773 9.55249 5.33818L7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925ZM11.7229 7.50857C11.8146 7.50299 11.9071 7.50016 12.0003 7.50016C14.4855 7.50016 16.5003 9.51488 16.5003 12.0002C16.5003 12.0933 16.4974 12.1858 16.4919 12.2775L11.7229 7.50857Z"></path>
  </svg>
);
export const eyeLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"></path>
  </svg>
);
export const notificationLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M22 20H2V18H3V11.0314C3 6.04348 7.02944 2 12 2C16.9706 2 21 6.04348 21 11.0314V18H22V20ZM5 18H19V11.0314C19 7.14806 15.866 4 12 4C8.13401 4 5 7.14806 5 11.0314V18ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z"></path>
  </svg>
);
export const userLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H18C18 18.6863 15.3137 16 12 16C8.68629 16 6 18.6863 6 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z"></path>
  </svg>
);
export const errorWarningLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z"></path>
  </svg>
);
export const messageLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM5.76282 17H20V5H4V18.3851L5.76282 17ZM11 10H13V12H11V10ZM7 10H9V12H7V10ZM15 10H17V12H15V10Z"></path>
  </svg>
);
export const addLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z"></path>
  </svg>
);
export const translateLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M18.5 10L22.9 21H20.745L19.544 18H15.454L14.255 21H12.101L16.5 10H18.5ZM10 2V4H16V6L14.0322 6.0006C13.2425 8.36616 11.9988 10.5057 10.4115 12.301C11.1344 12.9457 11.917 13.5176 12.7475 14.0079L11.9969 15.8855C10.9237 15.2781 9.91944 14.5524 8.99961 13.7249C7.21403 15.332 5.10914 16.5553 2.79891 17.2734L2.26257 15.3442C4.2385 14.7203 6.04543 13.6737 7.59042 12.3021C6.46277 11.0281 5.50873 9.57985 4.76742 8.00028L7.00684 8.00037C7.57018 9.03885 8.23979 10.0033 8.99967 10.877C10.2283 9.46508 11.2205 7.81616 11.9095 6.00101L2 6V4H8V2H10ZM17.5 12.8852L16.253 16H18.745L17.5 12.8852Z"></path>
  </svg>
);
export const questionnaireLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M5.76282 17H20V5H4V18.3851L5.76282 17ZM6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM11 14H13V16H11V14ZM8.56731 8.81346C8.88637 7.20919 10.302 6 12 6C13.933 6 15.5 7.567 15.5 9.5C15.5 11.433 13.933 13 12 13H11V11H12C12.8284 11 13.5 10.3284 13.5 9.5C13.5 8.67157 12.8284 8 12 8C11.2723 8 10.6656 8.51823 10.5288 9.20577L8.56731 8.81346Z"></path>
  </svg>
);
export const headphoneLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 4C7.58172 4 4 7.58172 4 12H7C8.10457 12 9 12.8954 9 14V19C9 20.1046 8.10457 21 7 21H4C2.89543 21 2 20.1046 2 19V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V19C22 20.1046 21.1046 21 20 21H17C15.8954 21 15 20.1046 15 19V14C15 12.8954 15.8954 12 17 12H20C20 7.58172 16.4183 4 12 4ZM4 14V19H7V14H4ZM17 14V19H20V14H17Z"></path>
  </svg>
);
export const settingLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M8.68637 4.00008L11.293 1.39348C11.6835 1.00295 12.3167 1.00295 12.7072 1.39348L15.3138 4.00008H19.0001C19.5524 4.00008 20.0001 4.4478 20.0001 5.00008V8.68637L22.6067 11.293C22.9972 11.6835 22.9972 12.3167 22.6067 12.7072L20.0001 15.3138V19.0001C20.0001 19.5524 19.5524 20.0001 19.0001 20.0001H15.3138L12.7072 22.6067C12.3167 22.9972 11.6835 22.9972 11.293 22.6067L8.68637 20.0001H5.00008C4.4478 20.0001 4.00008 19.5524 4.00008 19.0001V15.3138L1.39348 12.7072C1.00295 12.3167 1.00295 11.6835 1.39348 11.293L4.00008 8.68637V5.00008C4.00008 4.4478 4.4478 4.00008 5.00008 4.00008H8.68637ZM6.00008 6.00008V9.5148L3.5148 12.0001L6.00008 14.4854V18.0001H9.5148L12.0001 20.4854L14.4854 18.0001H18.0001V14.4854L20.4854 12.0001L18.0001 9.5148V6.00008H14.4854L12.0001 3.5148L9.5148 6.00008H6.00008ZM12.0001 16.0001C9.79094 16.0001 8.00008 14.2092 8.00008 12.0001C8.00008 9.79094 9.79094 8.00008 12.0001 8.00008C14.2092 8.00008 16.0001 9.79094 16.0001 12.0001C16.0001 14.2092 14.2092 16.0001 12.0001 16.0001ZM12.0001 14.0001C13.1047 14.0001 14.0001 13.1047 14.0001 12.0001C14.0001 10.8955 13.1047 10.0001 12.0001 10.0001C10.8955 10.0001 10.0001 10.8955 10.0001 12.0001C10.0001 13.1047 10.8955 14.0001 12.0001 14.0001Z"></path>
  </svg>
);
export const fileUnknownLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M11 15H13V17H11V15ZM13 13.3551V14H11V12.5C11 11.9477 11.4477 11.5 12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.2723 8.5 10.6656 9.01823 10.5288 9.70577L8.56731 9.31346C8.88637 7.70919 10.302 6.5 12 6.5C13.933 6.5 15.5 8.067 15.5 10C15.5 11.5855 14.4457 12.9248 13 13.3551ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"></path>
  </svg>
);
export const fileTextLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M21 8V20.9932C21 21.5501 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8ZM19 9H14V4H5V20H19V9ZM8 7H11V9H8V7ZM8 11H16V13H8V11ZM8 15H16V17H8V15Z"></path>
  </svg>
);
export const pieChartLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M9 2.4578V4.58152C6.06817 5.76829 4 8.64262 4 12C4 16.4183 7.58172 20 12 20C15.3574 20 18.2317 17.9318 19.4185 15H21.5422C20.2679 19.0571 16.4776 22 12 22C6.47715 22 2 17.5228 2 12C2 7.52236 4.94289 3.73207 9 2.4578ZM12 2C17.5228 2 22 6.47715 22 12C22 12.3375 21.9833 12.6711 21.9506 13H11V2.04938C11.3289 2.01672 11.6625 2 12 2ZM13 4.06189V11H19.9381C19.4869 7.38128 16.6187 4.51314 13 4.06189Z"></path>
  </svg>
);
export const chatLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M10 3H14C18.4183 3 22 6.58172 22 11C22 15.4183 18.4183 19 14 19V22.5C9 20.5 2 17.5 2 11C2 6.58172 5.58172 3 10 3ZM12 17H14C17.3137 17 20 14.3137 20 11C20 7.68629 17.3137 5 14 5H10C6.68629 5 4 7.68629 4 11C4 14.61 6.46208 16.9656 12 19.4798V17Z"></path>
  </svg>
);
export const fileWarnignLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z"></path>
  </svg>
);
export const auctionLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M14.0049 20.0028V22.0028H2.00488V20.0028H14.0049ZM14.5907 0.689087L22.3688 8.46726L20.9546 9.88147L19.894 9.52792L17.4191 12.0028L23.076 17.6597L21.6617 19.0739L16.0049 13.417L13.6007 15.8212L13.8836 16.9525L12.4693 18.3668L4.69117 10.5886L6.10539 9.17437L7.23676 9.45721L13.53 3.16396L13.1765 2.1033L14.5907 0.689087ZM15.2978 4.22462L8.22671 11.2957L11.7622 14.8312L18.8333 7.76015L15.2978 4.22462Z"></path>
  </svg>
);
export const equalizerLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M6.17071 18C6.58254 16.8348 7.69378 16 9 16C10.3062 16 11.4175 16.8348 11.8293 18H22V20H11.8293C11.4175 21.1652 10.3062 22 9 22C7.69378 22 6.58254 21.1652 6.17071 20H2V18H6.17071ZM12.1707 11C12.5825 9.83481 13.6938 9 15 9C16.3062 9 17.4175 9.83481 17.8293 11H22V13H17.8293C17.4175 14.1652 16.3062 15 15 15C13.6938 15 12.5825 14.1652 12.1707 13H2V11H12.1707ZM6.17071 4C6.58254 2.83481 7.69378 2 9 2C10.3062 2 11.4175 2.83481 11.8293 4H22V6H11.8293C11.4175 7.16519 10.3062 8 9 8C7.69378 8 6.58254 7.16519 6.17071 6H2V4H6.17071ZM9 6C9.55228 6 10 5.55228 10 5C10 4.44772 9.55228 4 9 4C8.44772 4 8 4.44772 8 5C8 5.55228 8.44772 6 9 6ZM15 13C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12C14 12.5523 14.4477 13 15 13ZM9 20C9.55228 20 10 19.5523 10 19C10 18.4477 9.55228 18 9 18C8.44772 18 8 18.4477 8 19C8 19.5523 8.44772 20 9 20Z"></path>
  </svg>
);
export const groupLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M2 22C2 17.5817 5.58172 14 10 14C14.4183 14 18 17.5817 18 22H16C16 18.6863 13.3137 16 10 16C6.68629 16 4 18.6863 4 22H2ZM10 13C6.685 13 4 10.315 4 7C4 3.685 6.685 1 10 1C13.315 1 16 3.685 16 7C16 10.315 13.315 13 10 13ZM10 11C12.21 11 14 9.21 14 7C14 4.79 12.21 3 10 3C7.79 3 6 4.79 6 7C6 9.21 7.79 11 10 11ZM18.2837 14.7028C21.0644 15.9561 23 18.752 23 22H21C21 19.564 19.5483 17.4671 17.4628 16.5271L18.2837 14.7028ZM17.5962 3.41321C19.5944 4.23703 21 6.20361 21 8.5C21 11.3702 18.8042 13.7252 16 13.9776V11.9646C17.6967 11.7222 19 10.264 19 8.5C19 7.11935 18.2016 5.92603 17.041 5.35635L17.5962 3.41321Z"></path>
  </svg>
);
export const teamLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 11C14.7614 11 17 13.2386 17 16V22H15V16C15 14.4023 13.7511 13.0963 12.1763 13.0051L12 13C10.4023 13 9.09634 14.2489 9.00509 15.8237L9 16V22H7V16C7 13.2386 9.23858 11 12 11ZM5.5 14C5.77885 14 6.05009 14.0326 6.3101 14.0942C6.14202 14.594 6.03873 15.122 6.00896 15.6693L6 16L6.0007 16.0856C5.88757 16.0456 5.76821 16.0187 5.64446 16.0069L5.5 16C4.7203 16 4.07955 16.5949 4.00687 17.3555L4 17.5V22H2V17.5C2 15.567 3.567 14 5.5 14ZM18.5 14C20.433 14 22 15.567 22 17.5V22H20V17.5C20 16.7203 19.4051 16.0796 18.6445 16.0069L18.5 16C18.3248 16 18.1566 16.03 18.0003 16.0852L18 16C18 15.3343 17.8916 14.694 17.6915 14.0956C17.9499 14.0326 18.2211 14 18.5 14ZM5.5 8C6.88071 8 8 9.11929 8 10.5C8 11.8807 6.88071 13 5.5 13C4.11929 13 3 11.8807 3 10.5C3 9.11929 4.11929 8 5.5 8ZM18.5 8C19.8807 8 21 9.11929 21 10.5C21 11.8807 19.8807 13 18.5 13C17.1193 13 16 11.8807 16 10.5C16 9.11929 17.1193 8 18.5 8ZM5.5 10C5.22386 10 5 10.2239 5 10.5C5 10.7761 5.22386 11 5.5 11C5.77614 11 6 10.7761 6 10.5C6 10.2239 5.77614 10 5.5 10ZM18.5 10C18.2239 10 18 10.2239 18 10.5C18 10.7761 18.2239 11 18.5 11C18.7761 11 19 10.7761 19 10.5C19 10.2239 18.7761 10 18.5 10ZM12 2C14.2091 2 16 3.79086 16 6C16 8.20914 14.2091 10 12 10C9.79086 10 8 8.20914 8 6C8 3.79086 9.79086 2 12 2ZM12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4Z"></path>
  </svg>
);
export const briefcaseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM4 16V19H20V16H4ZM4 14H20V7H4V14ZM9 3V5H15V3H9ZM11 11H13V13H11V11Z"></path>
  </svg>
);
export const ticketLine2Icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M21.0049 2.99979C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V9.49979C20.6242 9.49979 19.5049 10.6191 19.5049 11.9998C19.5049 13.3805 20.6242 14.4998 22.0049 14.4998V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V14.4998C3.38559 14.4998 4.50488 13.3805 4.50488 11.9998C4.50488 10.6191 3.38559 9.49979 2.00488 9.49979V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H21.0049ZM20.0049 4.99979H4.00488V7.96779L4.16077 8.04886C5.49935 8.78084 6.42516 10.1733 6.49998 11.788L6.50488 11.9998C6.50488 13.704 5.55755 15.1869 4.16077 15.9507L4.00488 16.0308V18.9998H20.0049V16.0308L19.849 15.9507C18.5104 15.2187 17.5846 13.8263 17.5098 12.2116L17.5049 11.9998C17.5049 10.2956 18.4522 8.81266 19.849 8.04886L20.0049 7.96779V4.99979ZM16.0049 8.99979V14.9998H8.00488V8.99979H16.0049Z"></path>
  </svg>
);
export const ticketLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M21.0049 2.99979C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V9.49979C20.6242 9.49979 19.5049 10.6191 19.5049 11.9998C19.5049 13.3805 20.6242 14.4998 22.0049 14.4998V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V14.4998C3.38559 14.4998 4.50488 13.3805 4.50488 11.9998C4.50488 10.6191 3.38559 9.49979 2.00488 9.49979V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H21.0049ZM20.0049 4.99979H4.00488V7.96779L4.16077 8.04886C5.49935 8.78084 6.42516 10.1733 6.49998 11.788L6.50488 11.9998C6.50488 13.704 5.55755 15.1869 4.16077 15.9507L4.00488 16.0308V18.9998H20.0049V16.0308L19.849 15.9507C18.5104 15.2187 17.5846 13.8263 17.5098 12.2116L17.5049 11.9998C17.5049 10.2956 18.4522 8.81266 19.849 8.04886L20.0049 7.96779V4.99979Z"></path>
  </svg>
);
export const layoutGridIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM11 13H4V19H11V13ZM20 13H13V19H20V13ZM11 5H4V11H11V5ZM20 5H13V11H20V5Z"></path>
  </svg>
);
export const moreFillIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 3C10.9 3 10 3.9 10 5C10 6.1 10.9 7 12 7C13.1 7 14 6.1 14 5C14 3.9 13.1 3 12 3ZM12 17C10.9 17 10 17.9 10 19C10 20.1 10.9 21 12 21C13.1 21 14 20.1 14 19C14 17.9 13.1 17 12 17ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"></path>
  </svg>
);
export const layoutColumnLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M11 5H5V19H11V5ZM13 5V19H19V5H13ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"></path>
  </svg>
);
export const downloadLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M3 19H21V21H3V19ZM13 13.1716L19.0711 7.1005L20.4853 8.51472L12 17L3.51472 8.51472L4.92893 7.1005L11 13.1716V2H13V13.1716Z"></path>
  </svg>
);
export const filterLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z"></path>
  </svg>
);
export const searchLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="currentColor"
  >
    <path d="M11 2C15.968 2 20 6.032 20 11C20 15.968 15.968 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2ZM11 18C14.8675 18 18 14.8675 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18ZM19.4853 18.0711L22.3137 20.8995L20.8995 22.3137L18.0711 19.4853L19.4853 18.0711Z"></path>
  </svg>
);

export const dotIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="6"
    viewBox="0 0 6 6"
    fill="none"
    preserveAspectRatio="xMidYMid meet"
  >
    <circle cx="3" cy="3" r="3" fill="currentColor" />
  </svg>
);
export const alarWarningLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width="11.03"
    height="12"
  >
    <path d="M4.00001 20V14C4.00001 9.58172 7.58173 6 12 6C16.4183 6 20 9.58172 20 14V20H21V22H3.00001V20H4.00001ZM6.00001 20H18V14C18 10.6863 15.3137 8 12 8C8.6863 8 6.00001 10.6863 6.00001 14V20ZM11 2H13V5H11V2ZM19.7782 4.80761L21.1924 6.22183L19.0711 8.34315L17.6569 6.92893L19.7782 4.80761ZM2.80762 6.22183L4.22183 4.80761L6.34315 6.92893L4.92894 8.34315L2.80762 6.22183ZM7.00001 14C7.00001 11.2386 9.23858 9 12 9V11C10.3432 11 9.00001 12.3431 9.00001 14H7.00001Z"></path>
  </svg>
);
export const equalLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width="7"
    height="4"
  >
    <path d="M19 8H5V10H19V8ZM19 14H5V16H19V14Z" />
  </svg>
);
export const arrowUpDoubleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width="6.9"
    height="7.37"
  >
    <path d="M12 4.83582L5.79291 11.0429L7.20712 12.4571L12 7.66424L16.7929 12.4571L18.2071 11.0429L12 4.83582ZM12 10.4857L5.79291 16.6928L7.20712 18.107L12 13.3141L16.7929 18.107L18.2071 16.6928L12 10.4857Z"></path>
  </svg>
);
export const arrowDownDoubleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="6.9"
    height="7.37"
    fill="currentColor"
  >
    <path d="M12 19.1642L18.2071 12.9571L16.7929 11.5429L12 16.3358L7.20712 11.5429L5.79291 12.9571L12 19.1642ZM12 13.5143L18.2071 7.30722L16.7929 5.89301L12 10.6859L7.20712 5.89301L5.79291 7.30722L12 13.5143Z" />
  </svg>
);
export const leftArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
  >
    <path
      d="M4.245 6.1002H15.1998V7.9002H4.245L9.07261 12.7278L7.8 14.0004L0.799805 7.0002L7.8 0L9.07261 1.2726L4.245 6.1002Z"
      fill="#0A0D14"
    />
  </svg>
);
export const starFillIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M17.75 6.69221L11.5925 5.95272L8.99671 0.25L6.40096 5.95272L0.25 6.69221L4.7975 10.9626L3.59491 17.125L8.99671 14.0538L14.4051 17.125L13.2025 10.9626L17.75 6.69221Z"
      fill="#F2AE40"
    />
  </svg>
);
export const starIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M14.4117 17.125L9.00329 14.0526L3.59491 17.125L4.80407 10.9602L0.25 6.69476L6.40096 5.95498L8.99671 0.25L11.5925 5.95498L17.75 6.69476L13.2025 10.9602L14.4117 17.125ZM9.00329 12.5264L12.5651 14.5458L11.7699 10.487L14.7665 7.67447L10.7119 7.18794L9.00329 3.42906L7.29469 7.18794L3.24005 7.67447L6.23667 10.487L5.44151 14.5458L9.00329 12.5264Z"
      fill="#CDD0D5"
    />
  </svg>
);
export const smileyStarIcon = (
  <svg width="22" height="21" viewBox="0 0 22 21" fill="none">
    <path
      d="M11 0.649902L14.8034 6.2146L21.2717 8.1127L17.1542 13.4497L17.3477 20.1871L11 17.9209L4.65227 20.1871L4.84577 13.4497L0.728271 8.1127L7.19657 6.2146L11 0.649902ZM11 3.8395L8.31977 7.7617L3.76127 9.0982L6.66377 12.8584L6.52607 17.6059L11 16.0093L15.473 17.6059L15.3362 12.8584L18.2378 9.0982L13.6802 7.7617L11 3.8395ZM9.19997 10.9999C9.19997 11.4773 9.38961 11.9351 9.72718 12.2727C10.0647 12.6103 10.5226 12.7999 11 12.7999C11.4774 12.7999 11.9352 12.6103 12.2728 12.2727C12.6103 11.9351 12.8 11.4773 12.8 10.9999H14.6C14.6 11.9547 14.2207 12.8704 13.5456 13.5455C12.8704 14.2206 11.9548 14.5999 11 14.5999C10.0452 14.5999 9.12952 14.2206 8.45439 13.5455C7.77926 12.8704 7.39997 11.9547 7.39997 10.9999H9.19997Z"
      fill="#525866"
    />
  </svg>
);
export const ticketSupportIcon = (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.75 0.25C14.9489 0.25 15.1397 0.329018 15.2803 0.46967C15.421 0.610322 15.5 0.801088 15.5 1V5.125C15.0027 5.125 14.5258 5.32254 14.1742 5.67417C13.8225 6.02581 13.625 6.50272 13.625 7C13.625 7.49728 13.8225 7.97419 14.1742 8.32582C14.5258 8.67746 15.0027 8.875 15.5 8.875V13C15.5 13.1989 15.421 13.3897 15.2803 13.5303C15.1397 13.671 14.9489 13.75 14.75 13.75H1.25C1.05109 13.75 0.860322 13.671 0.71967 13.5303C0.579018 13.3897 0.5 13.1989 0.5 13V8.875C0.997281 8.875 1.47419 8.67746 1.82583 8.32582C2.17746 7.97419 2.375 7.49728 2.375 7C2.375 6.50272 2.17746 6.02581 1.82583 5.67417C1.47419 5.32254 0.997281 5.125 0.5 5.125V1C0.5 0.801088 0.579018 0.610322 0.71967 0.46967C0.860322 0.329018 1.05109 0.25 1.25 0.25H14.75ZM14 1.75H2V3.976L2.117 4.03675C2.62574 4.31428 3.05445 4.71814 3.36183 5.20943C3.66921 5.70071 3.8449 6.26286 3.872 6.84175L3.875 7C3.87509 7.60618 3.71189 8.20119 3.40254 8.7225C3.09319 9.2438 2.64912 9.67214 2.117 9.9625L2 10.024V12.25H14V10.0233L13.883 9.96325C13.3743 9.68571 12.9456 9.28186 12.6382 8.79057C12.3308 8.29929 12.1551 7.73714 12.128 7.15825L12.125 7C12.125 5.722 12.8352 4.60975 13.883 4.0375L14 3.97525V1.75Z"
      fill="#525866"
    />
  </svg>
);
export const userManualIcon = (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.75 2H3.25C2.85218 2 2.47064 2.15804 2.18934 2.43934C1.90804 2.72064 1.75 3.10218 1.75 3.5C1.75 3.89782 1.90804 4.27936 2.18934 4.56066C2.47064 4.84196 2.85218 5 3.25 5H13.75V14.75C13.75 14.9489 13.671 15.1397 13.5303 15.2803C13.3897 15.421 13.1989 15.5 13 15.5H3.25C2.45435 15.5 1.69129 15.1839 1.12868 14.6213C0.56607 14.0587 0.25 13.2956 0.25 12.5V3.5C0.25 2.70435 0.56607 1.94129 1.12868 1.37868C1.69129 0.816071 2.45435 0.5 3.25 0.5H13C13.1989 0.5 13.3897 0.579018 13.5303 0.71967C13.671 0.860322 13.75 1.05109 13.75 1.25V2ZM1.75 12.5C1.75 12.8978 1.90804 13.2794 2.18934 13.5607C2.47064 13.842 2.85218 14 3.25 14H12.25V6.5H3.25C2.72337 6.50084 2.20588 6.36241 1.75 6.09875V12.5ZM13 4.25H3.25C3.05109 4.25 2.86032 4.17098 2.71967 4.03033C2.57902 3.88968 2.5 3.69891 2.5 3.5C2.5 3.30109 2.57902 3.11032 2.71967 2.96967C2.86032 2.82902 3.05109 2.75 3.25 2.75H13V4.25Z"
      fill="#525866"
    />
  </svg>
);
export const videoTutorialIcon = (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.875 2V4.5H10.375V12H1.625V2H7.875ZM0.999063 0.75C0.654681 0.75 0.375 1.02753 0.375 1.36988V12.6301C0.375 12.9654 0.652975 13.25 0.995875 13.25H11.0041C11.3469 13.25 11.625 12.9681 11.625 12.6203L11.6248 3.875L8.5 0.75H0.999063ZM7.8755 6.79187L4.82619 4.75897C4.78512 4.73159 4.73687 4.71698 4.6875 4.71698C4.54944 4.71698 4.4375 4.82891 4.4375 4.96698V9.03275C4.4375 9.08213 4.45212 9.13037 4.4795 9.17144C4.55606 9.28631 4.71131 9.31738 4.82619 9.24075L7.8755 7.20787C7.90294 7.18956 7.9265 7.166 7.94481 7.13856C8.02144 7.02369 7.99038 6.86844 7.8755 6.79187Z"
      fill="#525866"
    />
  </svg>
);
export const customerServiceIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.1 6.40011C18.5774 6.40011 19.0352 6.58975 19.3728 6.92731C19.7103 7.26488 19.9 7.72272 19.9 8.20011V11.8001C19.9 12.2775 19.7103 12.7353 19.3728 13.0729C19.0352 13.4105 18.5774 13.6001 18.1 13.6001H17.1442C16.9248 15.3401 16.0779 16.9402 14.7625 18.1001C13.4472 19.26 11.7537 19.9001 9.99998 19.9001V18.1001C11.4321 18.1001 12.8057 17.5312 13.8184 16.5185C14.831 15.5058 15.4 14.1323 15.4 12.7001V7.30011C15.4 5.86794 14.831 4.49443 13.8184 3.48173C12.8057 2.46903 11.4321 1.90011 9.99998 1.90011C8.56781 1.90011 7.1943 2.46903 6.1816 3.48173C5.1689 4.49443 4.59998 5.86794 4.59998 7.30011V13.6001H1.89998C1.42259 13.6001 0.964749 13.4105 0.627183 13.0729C0.289618 12.7353 0.0999756 12.2775 0.0999756 11.8001V8.20011C0.0999756 7.72272 0.289618 7.26488 0.627183 6.92731C0.964749 6.58975 1.42259 6.40011 1.89998 6.40011H2.85578C3.0754 4.66031 3.92235 3.06045 5.23769 1.90071C6.55304 0.740977 8.24637 0.101074 9.99998 0.101074C11.7536 0.101074 13.4469 0.740977 14.7623 1.90071C16.0776 3.06045 16.9245 4.66031 17.1442 6.40011H18.1ZM6.18398 13.4066L7.13798 11.8802C7.99574 12.4175 8.98781 12.7017 9.99998 12.7001C11.0121 12.7017 12.0042 12.4175 12.862 11.8802L13.816 13.4066C12.6723 14.1231 11.3496 14.5022 9.99998 14.5001C8.65039 14.5022 7.32764 14.1231 6.18398 13.4066Z"
      fill="#0A0D14"
    />
  </svg>
);
export const searchIconWithLongTail = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M11.0282 11.7179L6.84099 7.53075C6.50766 7.80596 6.12433 8.02135 5.69099 8.1769C5.25766 8.33246 4.80937 8.41023 4.34613 8.41023C3.20668 8.41023 2.24234 8.01571 1.45309 7.22667C0.663848 6.43762 0.269226 5.47353 0.269226 4.33438C0.269226 3.19523 0.663748 2.23078 1.45279 1.44103C2.24184 0.6513 3.20594 0.256433 4.34509 0.256433C5.48424 0.256433 6.44868 0.651057 7.23843 1.4403C8.02817 2.22955 8.42304 3.19389 8.42304 4.33333C8.42304 4.8094 8.34313 5.2641 8.18329 5.69743C8.02346 6.13077 7.81021 6.50769 7.54354 6.8282L11.7307 11.0154L11.0282 11.7179ZM4.34613 7.41027C5.2051 7.41027 5.93267 7.11219 6.52883 6.51603C7.12498 5.91988 7.42306 5.19231 7.42306 4.33333C7.42306 3.47436 7.12498 2.74679 6.52883 2.15063C5.93267 1.55448 5.2051 1.2564 4.34613 1.2564C3.48715 1.2564 2.75958 1.55448 2.16343 2.15063C1.56728 2.74679 1.26921 3.47436 1.26921 4.33333C1.26921 5.19231 1.56728 5.91988 2.16343 6.51603C2.75958 7.11219 3.48715 7.41027 4.34613 7.41027Z"
      fill="#1C1B1F"
    />
  </svg>
);

export const searchIcon = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="9.16667"
      cy="9.16667"
      r="6.41667"
      stroke="#4B465C"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="9.16667"
      cy="9.16667"
      r="6.41667"
      stroke="white"
      strokeOpacity="0.2"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.25 19.25L13.75 13.75"
      stroke="#4B465C"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.25 19.25L13.75 13.75"
      stroke="white"
      strokeOpacity="0.2"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const emptyListIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="251"
    height="273"
    viewBox="0 0 251 273"
    fill="none"
  >
    <path
      d="M125 250.18C194.036 250.18 250 194.175 250 125.09C250 56.0047 194.036 0 125 0C55.9644 0 0 56.0047 0 125.09C0 194.175 55.9644 250.18 125 250.18Z"
      fill="#EAEEF9"
    />
    <g filter="url(#filter0_d_253_2731)">
      <path
        d="M218.386 239.296H33.6443C27.9696 239.296 23.2407 234.721 23.2407 228.885V21.2955C23.2407 15.6168 27.812 11.0422 33.6443 11.0422H218.386C224.06 11.0422 228.789 15.6168 228.789 21.4533V228.885C228.789 234.564 224.218 239.296 218.386 239.296Z"
        fill="url(#paint0_linear_253_2731)"
      />
    </g>
    <path
      d="M206.878 73.6663H43.8895C41.9979 73.6663 40.4216 72.0889 40.4216 70.196V39.2784C40.4216 37.3855 41.9979 35.8081 43.8895 35.8081H206.878C208.77 35.8081 210.346 37.3855 210.346 39.2784V70.0383C210.504 72.0889 208.927 73.6663 206.878 73.6663Z"
      fill="#EAEEF9"
    />
    <path
      d="M57.4467 59.4692C60.0583 59.4692 62.1755 57.3505 62.1755 54.7369C62.1755 52.1234 60.0583 50.0046 57.4467 50.0046C54.835 50.0046 52.7178 52.1234 52.7178 54.7369C52.7178 57.3505 54.835 59.4692 57.4467 59.4692Z"
      fill="#AAB2C5"
    />
    <path
      d="M173.776 57.892H78.0954C77.3073 57.892 76.6768 57.261 76.6768 56.4723V52.8442C76.6768 52.0555 77.3073 51.4246 78.0954 51.4246H173.776C174.565 51.4246 175.195 52.0555 175.195 52.8442V56.4723C175.195 57.261 174.565 57.892 173.776 57.892Z"
      fill="#AAB2C5"
    />
    <path
      d="M206.878 122.251H43.8895C41.9979 122.251 40.4216 120.673 40.4216 118.78V88.0204C40.4216 86.1275 41.9979 84.55 43.8895 84.55H206.878C208.77 84.55 210.346 86.1275 210.346 88.0204V118.78C210.504 120.673 208.927 122.251 206.878 122.251Z"
      fill="#EAEEF9"
    />
    <path
      d="M57.4467 108.053C60.0583 108.053 62.1755 105.935 62.1755 103.321C62.1755 100.708 60.0583 98.5889 57.4467 98.5889C54.835 98.5889 52.7178 100.708 52.7178 103.321C52.7178 105.935 54.835 108.053 57.4467 108.053Z"
      fill="#AAB2C5"
    />
    <path
      d="M173.776 106.634H78.0954C77.3073 106.634 76.6768 106.003 76.6768 105.215V101.586C76.6768 100.798 77.3073 100.167 78.0954 100.167H173.776C174.565 100.167 175.195 100.798 175.195 101.586V105.215C175.195 106.003 174.565 106.634 173.776 106.634Z"
      fill="#AAB2C5"
    />
    <path
      d="M206.878 219.578H43.8895C41.9979 219.578 40.4216 218.001 40.4216 216.108V185.348C40.4216 183.455 41.9979 181.877 43.8895 181.877H206.878C208.77 181.877 210.346 183.455 210.346 185.348V216.108C210.504 218.001 208.927 219.578 206.878 219.578Z"
      fill="#EAEEF9"
    />
    <path
      d="M57.4467 205.381C60.0583 205.381 62.1755 203.262 62.1755 200.649C62.1755 198.035 60.0583 195.916 57.4467 195.916C54.835 195.916 52.7178 198.035 52.7178 200.649C52.7178 203.262 54.835 205.381 57.4467 205.381Z"
      fill="#AAB2C5"
    />
    <path
      d="M173.776 203.804H78.0954C77.3073 203.804 76.6768 203.173 76.6768 202.384V198.756C76.6768 197.967 77.3073 197.336 78.0954 197.336H173.776C174.565 197.336 175.195 197.967 175.195 198.756V202.384C175.195 203.173 174.565 203.804 173.776 203.804Z"
      fill="#AAB2C5"
    />
    <path
      d="M243.29 169.835H80.3018C78.9632 169.835 77.834 168.706 77.834 167.365V136.605C77.834 135.264 78.9632 134.135 80.3018 134.135H243.29C244.629 134.135 245.758 135.264 245.758 136.605V167.365C245.758 168.706 244.629 169.835 243.29 169.835Z"
      fill="#D6DCE8"
      stroke="#AAB2C5"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M93.859 156.796C96.4707 156.796 98.5879 154.677 98.5879 152.064C98.5879 149.45 96.4707 147.331 93.859 147.331C91.2473 147.331 89.1301 149.45 89.1301 152.064C89.1301 154.677 91.2473 156.796 93.859 156.796Z"
      fill="#AAB2C5"
    />
    <path
      d="M210.189 155.219H114.508C113.72 155.219 113.089 154.588 113.089 153.799V150.171C113.089 149.382 113.72 148.751 114.508 148.751H210.189C210.977 148.751 211.607 149.382 211.607 150.171V153.799C211.607 154.588 210.977 155.219 210.189 155.219Z"
      fill="#AAB2C5"
    />
    <defs>
      <filter
        id="filter0_d_253_2731"
        x="1.24072"
        y="0.0422363"
        width="249.549"
        height="272.254"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_253_2731"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_253_2731"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_253_2731"
        x1="125.948"
        y1="5.76251"
        x2="125.948"
        y2="241.757"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset="0.9964" stopColor="#ECF0F5" />
      </linearGradient>
    </defs>
  </svg>
);

export const dragIcon = (
  <svg width="8" height="12" viewBox="0 0 8 12" fill="none">
    <path
      d="M1.4956 11.6795C1.17003 11.6795 0.892793 11.5635 0.66389 11.3317C0.435001 11.0999 0.320557 10.8212 0.320557 10.4956C0.320557 10.17 0.436481 9.89279 0.668328 9.66389C0.900161 9.435 1.17886 9.32056 1.50443 9.32056C1.83 9.32056 2.10724 9.43648 2.33614 9.66833C2.56503 9.90016 2.67947 10.1789 2.67947 10.5044C2.67947 10.83 2.56355 11.1072 2.3317 11.3361C2.09987 11.565 1.82117 11.6795 1.4956 11.6795ZM6.4956 11.6795C6.17003 11.6795 5.89279 11.5635 5.66389 11.3317C5.435 11.0999 5.32056 10.8212 5.32056 10.4956C5.32056 10.17 5.43648 9.89279 5.66833 9.66389C5.90016 9.435 6.17886 9.32056 6.50443 9.32056C6.83 9.32056 7.10724 9.43648 7.33614 9.66833C7.56503 9.90016 7.67947 10.1789 7.67947 10.5044C7.67947 10.83 7.56355 11.1072 7.3317 11.3361C7.09987 11.565 6.82117 11.6795 6.4956 11.6795ZM1.4956 7.17947C1.17003 7.17947 0.892793 7.06355 0.66389 6.8317C0.435001 6.59987 0.320557 6.32117 0.320557 5.9956C0.320557 5.67003 0.436481 5.39279 0.668328 5.16389C0.900161 4.935 1.17886 4.82056 1.50443 4.82056C1.83 4.82056 2.10724 4.93648 2.33614 5.16833C2.56503 5.40016 2.67947 5.67886 2.67947 6.00443C2.67947 6.33 2.56355 6.60724 2.3317 6.83614C2.09987 7.06503 1.82117 7.17947 1.4956 7.17947ZM6.4956 7.17947C6.17003 7.17947 5.89279 7.06355 5.66389 6.8317C5.435 6.59987 5.32056 6.32117 5.32056 5.9956C5.32056 5.67003 5.43648 5.39279 5.66833 5.16389C5.90016 4.935 6.17886 4.82056 6.50443 4.82056C6.83 4.82056 7.10724 4.93648 7.33614 5.16833C7.56503 5.40016 7.67947 5.67886 7.67947 6.00443C7.67947 6.33 7.56355 6.60724 7.3317 6.83614C7.09987 7.06503 6.82117 7.17947 6.4956 7.17947ZM1.4956 2.67947C1.17003 2.67947 0.892793 2.56355 0.66389 2.3317C0.435001 2.09987 0.320557 1.82117 0.320557 1.4956C0.320557 1.17003 0.436481 0.892794 0.668328 0.663891C0.900161 0.435002 1.17886 0.320557 1.50443 0.320557C1.83 0.320557 2.10724 0.43648 2.33614 0.668327C2.56503 0.900161 2.67947 1.17886 2.67947 1.50443C2.67947 1.83 2.56355 2.10724 2.3317 2.33614C2.09987 2.56503 1.82117 2.67947 1.4956 2.67947ZM6.4956 2.67947C6.17003 2.67947 5.89279 2.56355 5.66389 2.3317C5.435 2.09987 5.32056 1.82117 5.32056 1.4956C5.32056 1.17003 5.43648 0.892794 5.66833 0.663891C5.90016 0.435002 6.17886 0.320557 6.50443 0.320557C6.83 0.320557 7.10724 0.43648 7.33614 0.668327C7.56503 0.900161 7.67947 1.17886 7.67947 1.50443C7.67947 1.83 7.56355 2.10724 7.3317 2.33614C7.09987 2.56503 6.82117 2.67947 6.4956 2.67947Z"
      fill="#888888"
    />
  </svg>
);

export const eyeIcon = (
  <svg width="14" height="10" viewBox="0 0 14 10" fill="none">
    <path
      d="M7.00145 7.51794C7.70129 7.51794 8.29565 7.273 8.78454 6.78311C9.27343 6.29321 9.51787 5.69833 9.51787 4.99849C9.51787 4.29866 9.27293 3.7043 8.78304 3.21541C8.29314 2.72652 7.69826 2.48207 6.99842 2.48207C6.29859 2.48207 5.70423 2.72702 5.21534 3.21691C4.72645 3.70681 4.482 4.30168 4.482 5.00152C4.482 5.70136 4.72695 6.29572 5.21684 6.78461C5.70674 7.2735 6.30161 7.51794 7.00145 7.51794ZM6.99994 6.60001C6.55549 6.60001 6.17771 6.44445 5.8666 6.13334C5.55549 5.82223 5.39994 5.44445 5.39994 5.00001C5.39994 4.55556 5.55549 4.17778 5.8666 3.86667C6.17771 3.55556 6.55549 3.40001 6.99994 3.40001C7.44438 3.40001 7.82216 3.55556 8.13327 3.86667C8.44438 4.17778 8.59994 4.55556 8.59994 5.00001C8.59994 5.44445 8.44438 5.82223 8.13327 6.13334C7.82216 6.44445 7.44438 6.60001 6.99994 6.60001ZM7.00085 9.46666C5.5056 9.46666 4.14317 9.06046 2.91359 8.24807C1.68399 7.43568 0.765769 6.353 0.158936 5.00001C0.765769 3.64702 1.68368 2.56433 2.91267 1.75194C4.14165 0.939551 5.50376 0.533356 6.99902 0.533356C8.49427 0.533356 9.8567 0.939551 11.0863 1.75194C12.3159 2.56433 13.2341 3.64702 13.8409 5.00001C13.2341 6.353 12.3162 7.43568 11.0872 8.24807C9.85823 9.06046 8.49611 9.46666 7.00085 9.46666ZM6.99994 8.60001C8.24438 8.60001 9.39438 8.27778 10.4499 7.63334C11.5055 6.9889 12.3166 6.11112 12.8833 5.00001C12.3166 3.8889 11.5055 3.01112 10.4499 2.36667C9.39438 1.72223 8.24438 1.40001 6.99994 1.40001C5.75549 1.40001 4.60549 1.72223 3.54994 2.36667C2.49438 3.01112 1.68327 3.8889 1.1166 5.00001C1.68327 6.11112 2.49438 6.9889 3.54994 7.63334C4.60549 8.27778 5.75549 8.60001 6.99994 8.60001Z"
      fill="#4B465C"
    />
  </svg>
);
export const toggleChevronIcon = (
  <svg width="6" height="8" viewBox="0 0 6 8" fill="none">
    <path
      d="M1.5 7L4.5 4L1.5 1"
      stroke="#464F60"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const toggleIcon = (
  <svg width="4" height="12" viewBox="0 0 4 12" fill="none">
    <path
      d="M1.99564 11.391C1.69652 11.391 1.44192 11.2845 1.23185 11.0715C1.02178 10.8584 0.916748 10.6024 0.916748 10.3033C0.916748 10.0041 1.02326 9.74954 1.23627 9.53948C1.44928 9.32941 1.70535 9.22438 2.00448 9.22438C2.3036 9.22438 2.5582 9.33089 2.76827 9.5439C2.97834 9.75691 3.08337 10.013 3.08337 10.3121C3.08337 10.6112 2.97687 10.8658 2.76385 11.0759C2.55084 11.286 2.29477 11.391 1.99564 11.391ZM1.99564 7.08332C1.69652 7.08332 1.44192 6.97681 1.23185 6.7638C1.02178 6.55078 0.916748 6.29471 0.916748 5.99559C0.916748 5.69646 1.02326 5.44186 1.23627 5.2318C1.44928 5.02173 1.70535 4.91669 2.00448 4.91669C2.3036 4.91669 2.5582 5.0232 2.76827 5.23621C2.97834 5.44923 3.08337 5.7053 3.08337 6.00442C3.08337 6.30355 2.97687 6.55814 2.76385 6.76821C2.55084 6.97828 2.29477 7.08332 1.99564 7.08332ZM1.99564 2.77563C1.69652 2.77563 1.44192 2.66912 1.23185 2.45611C1.02178 2.24309 0.916748 1.98702 0.916748 1.6879C0.916748 1.38877 1.02326 1.13418 1.23627 0.924108C1.44928 0.714052 1.70535 0.609024 2.00448 0.609024C2.3036 0.609024 2.5582 0.715532 2.76827 0.928546C2.97834 1.14156 3.08337 1.39763 3.08337 1.69675C3.08337 1.99588 2.97687 2.25047 2.76385 2.46052C2.55084 2.67059 2.29477 2.77563 1.99564 2.77563Z"
      fill="#1A355E"
    />
  </svg>
);
export const crossIcon = (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
    <g clipPath="url(#clip0_12_620)">
      <path
        d="M4.70696 3.99999L7.85351 0.85379C8.04883 0.65847 8.04883 0.341795 7.85351 0.14649C7.65819 -0.0488301 7.34151 -0.0488301 7.14621 0.14649L3.99999 3.29302L0.85379 0.14649C0.65847 -0.0488301 0.341795 -0.0488301 0.14649 0.14649C-0.0488144 0.341811 -0.0488301 0.658485 0.14649 0.85379L3.29302 3.99999L0.14649 7.14621C-0.0488301 7.34153 -0.0488301 7.65821 0.14649 7.85351C0.341811 8.04881 0.658485 8.04883 0.85379 7.85351L3.99999 4.70696L7.14619 7.85351C7.34151 8.04883 7.65819 8.04883 7.85349 7.85351C8.04881 7.65819 8.04881 7.34151 7.85349 7.14621L4.70696 3.99999Z"
        fill="#888888"
      />
    </g>
    <defs>
      <clipPath id="clip0_12_620">
        <rect width="8" height="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const columnsSelectorIcon = (
  <svg width="14" height="10" viewBox="0 0 14 10" fill="none">
    <path
      d="M1.87188 9.00002H4.55778V1.00001H1.87188C1.81205 1.00001 1.7629 1.01925 1.72443 1.05771C1.68596 1.09618 1.66673 1.14533 1.66673 1.20516V8.79486C1.66673 8.8547 1.68596 8.90385 1.72443 8.94231C1.7629 8.98078 1.81205 9.00002 1.87188 9.00002ZM5.55775 9.00002H8.44238V1.00001H5.55775V9.00002ZM9.44235 9.00002H12.1282C12.1881 9.00002 12.2372 8.98078 12.2757 8.94231C12.3142 8.90385 12.3334 8.8547 12.3334 8.79486V1.20516C12.3334 1.14533 12.3142 1.09618 12.2757 1.05771C12.2372 1.01925 12.1881 1.00001 12.1282 1.00001H9.44235V9.00002ZM1.87188 10C1.53513 10 1.25008 9.88333 1.01675 9.65C0.783415 9.41667 0.666748 9.13162 0.666748 8.79486V1.20516C0.666748 0.868409 0.783415 0.583364 1.01675 0.350031C1.25008 0.116697 1.53513 3.05176e-05 1.87188 3.05176e-05H12.1282C12.465 3.05176e-05 12.75 0.116697 12.9834 0.350031C13.2167 0.583364 13.3334 0.868409 13.3334 1.20516V8.79486C13.3334 9.13162 13.2167 9.41667 12.9834 9.65C12.75 9.88333 12.465 10 12.1282 10H1.87188Z"
      fill="#888888"
    />
  </svg>
);

export const downloadIcon = (
  <svg width="14" height="10" viewBox="0 0 14 10" fill="none">
    <path
      d="M1.87188 9.99998C1.53513 9.99998 1.25008 9.88332 1.01675 9.64998C0.783415 9.41665 0.666748 9.1316 0.666748 8.79485V1.20515C0.666748 0.868394 0.783415 0.583349 1.01675 0.350015C1.25008 0.116682 1.53513 1.52588e-05 1.87188 1.52588e-05H4.91031V0.999999H1.87188C1.82059 0.999999 1.77358 1.02137 1.73083 1.0641C1.6881 1.10684 1.66673 1.15386 1.66673 1.20515V8.79485C1.66673 8.84614 1.6881 8.89316 1.73083 8.9359C1.77358 8.97863 1.82059 9 1.87188 9H12.1282C12.1795 9 12.2266 8.97863 12.2693 8.9359C12.312 8.89316 12.3334 8.84614 12.3334 8.79485V1.20515C12.3334 1.15386 12.312 1.10684 12.2693 1.0641C12.2266 1.02137 12.1795 0.999999 12.1282 0.999999H9.08982V1.52588e-05H12.1282C12.465 1.52588e-05 12.75 0.116682 12.9834 0.350015C13.2167 0.583349 13.3334 0.868394 13.3334 1.20515V8.79485C13.3334 9.1316 13.2167 9.41665 12.9834 9.64998C12.75 9.88332 12.465 9.99998 12.1282 9.99998H1.87188ZM7.00006 7.09998L3.89751 3.99743L4.60006 3.2949L6.50008 5.1949V1.52588e-05H7.50005V5.1949L9.40007 3.2949L10.1026 3.99743L7.00006 7.09998Z"
      fill="#888888"
    />
  </svg>
);

export const downloadBarIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M3.25 15.25H16.75V16.75H3.25V15.25ZM10.75 10.879L15.3033 6.325L16.3638 7.3855L10 13.75L3.63625 7.38625L4.69675 6.325L9.25 10.8775V2.5H10.75V10.879Z" fill="#525866"/>
</svg>
);

export const filterLayersIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
  >
    <path
      d="M4.80001 7.6H7.20001V6.4H4.80001V7.6ZM0.600006 0.4V1.6H11.4V0.4H0.600006ZM2.40001 4.6H9.60001V3.4H2.40001V4.6Z"
      fill="#0A0D14"
    />
  </svg>
);

export const downChevronIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M5 6.5L8 9.5L11 6.5" stroke="#464F60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);
  export const TicketIcon = () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          d='M20.1 3.90002C20.3387 3.90002 20.5676 3.99485 20.7364 4.16363C20.9052 4.33241 21 4.56133 21 4.80002V9.75002C20.4033 9.75002 19.831 9.98708 19.409 10.409C18.9871 10.831 18.75 11.4033 18.75 12C18.75 12.5968 18.9871 13.1691 19.409 13.591C19.831 14.013 20.4033 14.25 21 14.25V19.2C21 19.4387 20.9052 19.6676 20.7364 19.8364C20.5676 20.0052 20.3387 20.1 20.1 20.1H3.9C3.66131 20.1 3.43239 20.0052 3.2636 19.8364C3.09482 19.6676 3 19.4387 3 19.2V14.25C3.59674 14.25 4.16903 14.013 4.59099 13.591C5.01295 13.1691 5.25 12.5968 5.25 12C5.25 11.4033 5.01295 10.831 4.59099 10.409C4.16903 9.98708 3.59674 9.75002 3 9.75002V4.80002C3 4.56133 3.09482 4.33241 3.2636 4.16363C3.43239 3.99485 3.66131 3.90002 3.9 3.90002H20.1ZM19.2 5.70002H4.8V8.37122L4.9404 8.44412C5.55089 8.77717 6.06533 9.2618 6.43419 9.85134C6.80305 10.4409 7.01389 11.1155 7.0464 11.8101L7.05 12C7.05011 12.7274 6.85427 13.4415 6.48305 14.067C6.11182 14.6926 5.57894 15.2066 4.9404 15.555L4.8 15.6288V18.3H19.2V15.6279L19.0596 15.5559C18.4491 15.2229 17.9347 14.7383 17.5658 14.1487C17.197 13.5592 16.9861 12.8846 16.9536 12.1899L16.95 12C16.95 10.4664 17.8023 9.13172 19.0596 8.44502L19.2 8.37032V5.70002Z'
          fill='#525866'
        />
      </svg>
    );
  };

  export const RefreshIcon = () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          d='M6.1167 5.18971C7.7498 3.7746 9.83909 2.99699 12 3.00001C16.9707 3.00001 21 7.02931 21 12C21 13.9224 20.397 15.7044 19.371 17.166L16.5 12H19.2C19.2001 10.5885 18.7853 9.20803 18.0072 8.03034C17.2291 6.85265 16.1219 5.92965 14.8235 5.37612C13.525 4.82259 12.0924 4.66294 10.704 4.91702C9.31548 5.17111 8.03231 5.82772 7.014 6.80521L6.1167 5.18971ZM17.8833 18.8103C16.2502 20.2254 14.1609 21.003 12 21C7.0293 21 3 16.9707 3 12C3 10.0776 3.603 8.29561 4.629 6.83401L7.5 12H4.8C4.79988 13.4115 5.21468 14.792 5.9928 15.9697C6.77093 17.1474 7.87806 18.0704 9.17654 18.6239C10.475 19.1774 11.9076 19.3371 13.296 19.083C14.6845 18.8289 15.9677 18.1723 16.986 17.1948L17.8833 18.8103Z'
          fill='#525866'
        />
      </svg>
    );
  };

  export const DoubleCheckIcon = () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          d='M11.6418 13.584L12.9126 14.8548L20.532 7.23535L21.8046 8.50795L12.9126 17.4L7.18498 11.6724L8.45758 10.3998L10.3701 12.3123L11.6418 13.5831V13.584ZM11.6436 11.0388L16.1004 6.58105L17.3694 7.85005L12.9126 12.3078L11.6436 11.0388ZM9.09928 16.1283L7.82758 17.4L2.09998 11.6724L3.37258 10.3998L4.64428 11.6715L4.64338 11.6724L9.09928 16.1283Z'
          fill='#525866'
        />
      </svg>
    );
  };

  export const TimerIcon = () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          d='M17.0562 6.57118L18.3639 5.26348L19.6365 6.53608L18.3288 7.84377C19.621 9.46123 20.2448 11.5121 20.0722 13.5751C19.8995 15.6381 18.9435 17.5567 17.4004 18.9369C15.8574 20.3171 13.8444 21.0541 11.775 20.9964C9.70555 20.9388 7.73671 20.091 6.27283 18.6271C4.80895 17.1633 3.96114 15.1944 3.90353 13.125C3.84592 11.0555 4.58288 9.04259 5.96306 7.49953C7.34323 5.95648 9.26185 5.00045 11.3249 4.8278C13.3879 4.65515 15.4388 5.27898 17.0562 6.57118ZM12 19.2C12.8273 19.2 13.6466 19.037 14.4109 18.7204C15.1753 18.4038 15.8698 17.9398 16.4548 17.3547C17.0398 16.7697 17.5038 16.0752 17.8204 15.3109C18.1371 14.5465 18.3 13.7273 18.3 12.9C18.3 12.0726 18.1371 11.2534 17.8204 10.4891C17.5038 9.72472 17.0398 9.03021 16.4548 8.4452C15.8698 7.86019 15.1753 7.39614 14.4109 7.07953C13.6466 6.76293 12.8273 6.59998 12 6.59998C10.3291 6.59998 8.72671 7.26372 7.54523 8.4452C6.36375 9.62668 5.7 11.2291 5.7 12.9C5.7 14.5708 6.36375 16.1733 7.54523 17.3547C8.72671 18.5362 10.3291 19.2 12 19.2ZM11.1 8.39997H12.9V13.8H11.1V8.39997ZM8.4 2.09998H15.6V3.89998H8.4V2.09998Z'
          fill='#525866'
        />
      </svg>
    );
  };

  export const ThumbDownIcon = () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          d='M14.34 15.6003L20.1 15.6003C20.5774 15.6003 21.0352 15.4106 21.3728 15.0731C21.7103 14.7355 21.9 14.2777 21.9 13.8003L21.9 11.9067C21.9002 11.6714 21.8544 11.4385 21.765 11.2209L18.9786 4.45827C18.9108 4.29335 18.7956 4.15226 18.6476 4.05292C18.4995 3.95357 18.3253 3.90044 18.147 3.90027L2.99999 3.90027C2.7613 3.90027 2.53238 3.99509 2.36359 4.16387C2.19481 4.33265 2.09999 4.56157 2.09999 4.80027L2.09999 13.8003C2.09999 14.039 2.19481 14.2679 2.36359 14.4367C2.53238 14.6054 2.7613 14.7003 2.99999 14.7003L6.13379 14.7003C6.27788 14.7002 6.41987 14.7348 6.54782 14.801C6.67577 14.8673 6.78595 14.9633 6.86909 15.081L11.7768 22.0344C11.8388 22.1223 11.9303 22.1851 12.0347 22.2113C12.139 22.2376 12.2493 22.2256 12.3456 22.1775L13.9782 21.3603C14.4376 21.1306 14.8047 20.7507 15.0183 20.2836C15.232 19.8165 15.2794 19.2903 15.1527 18.7926L14.34 15.6003ZM7.49999 13.2711L7.49999 5.70027L17.544 5.70027L20.1 11.9067L20.1 13.8003L14.34 13.8003C14.0659 13.8003 13.7953 13.863 13.5491 13.9835C13.3029 14.1039 13.0874 14.2791 12.9191 14.4955C12.7509 14.712 12.6343 14.964 12.5783 15.2323C12.5222 15.5007 12.5282 15.7783 12.5958 16.044L13.4085 19.2372C13.4339 19.3368 13.4245 19.4421 13.3818 19.5356C13.339 19.6291 13.2656 19.7051 13.1736 19.7511L12.5787 20.0481L8.33969 14.0433C8.11469 13.7247 7.82669 13.4637 7.49999 13.2711ZM5.69999 12.9003L3.89999 12.9003L3.89999 5.70027L5.69999 5.70027L5.69999 12.9003Z'
          fill='#525866'
        />
      </svg>
    );
  };

  export const Vector = ({ className }) => (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width='168'
      height='17'
      viewBox='0 0 168 17'
      fill='none'
    >
      <path
        d='M167.5 1L73.5 1.00001L59 15L45 1.00001L-1.22392e-06 1.00001'
        stroke='var(--secondary,$secondary)'
        strokeWidth='2'
      />
    </svg>
  );

  export const TimerLine = ({ color = '#525866', className }) => {
    return (
      <svg
        className={className}
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          d='M17.0562 6.5713L18.3639 5.2636L19.6365 6.5362L18.3288 7.8439C19.621 9.46135 20.2448 11.5122 20.0722 13.5752C19.8995 15.6382 18.9435 17.5569 17.4004 18.937C15.8574 20.3172 13.8444 21.0542 11.775 20.9966C9.70555 20.939 7.73671 20.0912 6.27283 18.6273C4.80895 17.1634 3.96114 15.1946 3.90353 13.1251C3.84592 11.0557 4.58288 9.04271 5.96306 7.49966C7.34323 5.9566 9.26185 5.00057 11.3249 4.82792C13.3879 4.65527 15.4388 5.2791 17.0562 6.5713ZM12 19.2001C12.8273 19.2001 13.6466 19.0371 14.4109 18.7205C15.1753 18.4039 15.8698 17.9399 16.4548 17.3549C17.0398 16.7699 17.5038 16.0754 17.8204 15.311C18.1371 14.5467 18.3 13.7274 18.3 12.9001C18.3 12.0728 18.1371 11.2535 17.8204 10.4892C17.5038 9.72484 17.0398 9.03033 16.4548 8.44532C15.8698 7.86032 15.1753 7.39626 14.4109 7.07966C13.6466 6.76305 12.8273 6.6001 12 6.6001C10.3291 6.6001 8.72671 7.26385 7.54523 8.44532C6.36375 9.6268 5.7 11.2292 5.7 12.9001C5.7 14.571 6.36375 16.1734 7.54523 17.3549C8.72671 18.5363 10.3291 19.2001 12 19.2001ZM11.1 8.4001H12.9V13.8001H11.1V8.4001ZM8.4 2.1001H15.6V3.9001H8.4V2.1001Z'
          fill={color}
        />
      </svg>
    );
  };

  export const BarChartLine = ({ color = '#525866', className }) => {
    return (
      <svg
        className={className}
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          d='M3 12.9H8.4V20.1H3V12.9ZM15.6 8.40002H21V20.1H15.6V8.40002ZM9.3 3.90002H14.7V20.1H9.3V3.90002ZM4.8 14.7V18.3H6.6V14.7H4.8ZM11.1 5.70002V18.3H12.9V5.70002H11.1ZM17.4 10.2V18.3H19.2V10.2H17.4Z'
          fill={color}
        />
      </svg>
    );
  };



export const exportFileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M2.3077 17.5C1.80257 17.5 1.375 17.325 1.025 16.975C0.675 16.625 0.5 16.1974 0.5 15.6923V2.30773C0.5 1.8026 0.675 1.37503 1.025 1.02503C1.375 0.675031 1.80257 0.500031 2.3077 0.500031H12.7884L17.5 5.21156V15.6923C17.5 16.1974 17.325 16.625 16.975 16.975C16.625 17.325 16.1974 17.5 15.6923 17.5H2.3077ZM2.3077 16H15.6923C15.782 16 15.8557 15.9712 15.9134 15.9135C15.9711 15.8558 16 15.782 16 15.6923V6.00001H12V2.00001H2.3077C2.21795 2.00001 2.14423 2.02886 2.08653 2.08656C2.02883 2.14426 1.99997 2.21798 1.99997 2.30773V15.6923C1.99997 15.782 2.02883 15.8558 2.08653 15.9135C2.14423 15.9712 2.21795 16 2.3077 16ZM4.25 13.5H13.75V12H4.25V13.5ZM4.25 6.00001H8.99998V4.50003H4.25V6.00001ZM4.25 9.74998H13.75V8.25003H4.25V9.74998Z"
      fill="#4B465C"
    />
  </svg>
);

export const exportPDFReportIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
  >
    <path
      d="M6.82685 10.4423H7.71147V8.44231H8.82685C9.07813 8.44231 9.28839 8.35769 9.45763 8.18846C9.62686 8.01924 9.71147 7.80899 9.71147 7.55771V6.44231C9.71147 6.19102 9.62686 5.98077 9.45763 5.81156C9.28839 5.64232 9.07813 5.55771 8.82685 5.55771H6.82685V10.4423ZM7.71147 7.55771V6.44231H8.82685V7.55771H7.71147ZM10.7307 10.4423H12.6922C12.9435 10.4423 13.1538 10.3577 13.323 10.1885C13.4922 10.0192 13.5768 9.80899 13.5768 9.55771V6.44231C13.5768 6.19102 13.4922 5.98077 13.323 5.81156C13.1538 5.64232 12.9435 5.55771 12.6922 5.55771H10.7307V10.4423ZM11.6153 9.55771V6.44231H12.6922V9.55771H11.6153ZM14.6922 10.4423H15.5768V8.44231H16.7692V7.55771H15.5768V6.44231H16.7692V5.55771H14.6922V10.4423ZM6.05765 15.5C5.55252 15.5 5.12496 15.325 4.77498 14.975C4.42498 14.625 4.24998 14.1974 4.24998 13.6923V2.30773C4.24998 1.8026 4.42498 1.37503 4.77498 1.02503C5.12496 0.675031 5.55252 0.500031 6.05765 0.500031H17.4422C17.9473 0.500031 18.3749 0.675031 18.7249 1.02503C19.0749 1.37503 19.2499 1.8026 19.2499 2.30773V13.6923C19.2499 14.1974 19.0749 14.625 18.7249 14.975C18.3749 15.325 17.9473 15.5 17.4422 15.5H6.05765ZM6.05765 14H17.4422C17.5191 14 17.5897 13.968 17.6538 13.9039C17.7179 13.8397 17.7499 13.7692 17.7499 13.6923V2.30773C17.7499 2.2308 17.7179 2.16027 17.6538 2.09616C17.5897 2.03206 17.5191 2.00001 17.4422 2.00001H6.05765C5.98072 2.00001 5.9102 2.03206 5.8461 2.09616C5.78198 2.16027 5.74993 2.2308 5.74993 2.30773V13.6923C5.74993 13.7692 5.78198 13.8397 5.8461 13.9039C5.9102 13.968 5.98072 14 6.05765 14ZM2.55768 18.9999C2.05256 18.9999 1.625 18.8249 1.275 18.4749C0.925 18.1249 0.75 17.6974 0.75 17.1923V4.30773H2.24998V17.1923C2.24998 17.2692 2.28202 17.3397 2.34613 17.4038C2.41024 17.4679 2.48076 17.5 2.55768 17.5H15.4422V18.9999H2.55768Z"
      fill="#4B465C"
    />
  </svg>
);

export const filterIcon2 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
  >
    <path
      d="M6.29339 15.1C5.97339 15.1 5.66006 15.02 5.36672 14.86C4.78006 14.5333 4.42672 13.94 4.42672 13.2733V9.74C4.42672 9.40667 4.20672 8.90667 4.00006 8.65333L1.50672 6.01333C1.08672 5.59333 0.766724 4.87333 0.766724 4.33333V2.8C0.766724 1.73333 1.57339 0.9 2.60006 0.9H11.4001C12.4134 0.9 13.2334 1.72 13.2334 2.73333V4.2C13.2334 4.9 12.8134 5.69333 12.4201 6.08667L9.53339 8.64C9.25339 8.87333 9.03339 9.38667 9.03339 9.8V12.6667C9.03339 13.26 8.66006 13.9467 8.19339 14.2267L7.27339 14.82C6.97339 15.0067 6.63339 15.1 6.29339 15.1ZM2.60006 1.9C2.13339 1.9 1.76672 2.29333 1.76672 2.8V4.33333C1.76672 4.58 1.96672 5.06 2.22006 5.31333L4.76006 7.98667C5.10006 8.40667 5.43339 9.10667 5.43339 9.73333V13.2667C5.43339 13.7 5.73339 13.9133 5.86006 13.98C6.14006 14.1333 6.48006 14.1333 6.74006 13.9733L7.66672 13.38C7.85339 13.2667 8.04006 12.9067 8.04006 12.6667V9.8C8.04006 9.08667 8.38672 8.3 8.88672 7.88L11.7401 5.35333C11.9667 5.12667 12.2401 4.58667 12.2401 4.19333V2.73333C12.2401 2.27333 11.8667 1.9 11.4067 1.9H2.60006Z"
      fill="#CDD0D5"
    />
  </svg>
);

export const filterIcon = (
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none">
    <path
      d="M5.82423 12.1058C5.70962 12.1058 5.61305 12.0673 5.53452 11.9901C5.456 11.913 5.41673 11.8169 5.41673 11.702V7.14909L0.68919 1.43117C0.612273 1.3286 0.601225 1.22097 0.656044 1.10826C0.710878 0.995549 0.800447 0.939194 0.924753 0.939194H11.0753C11.1996 0.939194 11.2892 0.995549 11.344 1.10826C11.3989 1.22097 11.3878 1.3286 11.3109 1.43117L6.58336 7.14909V11.702C6.58336 11.8169 6.54491 11.913 6.468 11.9901C6.3911 12.0673 6.29534 12.1058 6.18073 12.1058H5.82423ZM6.00004 6.14751L9.37504 2.02251H2.60421L6.00004 6.14751Z"
      fill="#1C1B1F"
    />
  </svg>
);

export const plusIcon = (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path
      d="M4.5 9.49998V5.49998H0.5V4.50002H4.5V0.500015H5.49997V4.50002H9.49997V5.49998H5.49997V9.49998H4.5Z"
      fill="#069AD5"
    />
  </svg>
);

export const rightToggleIcon = (
  <svg width="6" height="8" viewBox="0 0 6 8" fill="none">
    <path
      d="M1.39998 7.76921L0.780762 7.14999L3.93076 3.99999L0.780762 0.849991L1.39998 0.230774L5.1692 3.99999L1.39998 7.76921Z"
      fill="#00A0DF"
    />
  </svg>
);
export const ticketIcon = (
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none">
    <path
      d="M10 13C10.2833 13 10.5208 12.9042 10.7125 12.7125C10.9042 12.5208 11 12.2833 11 12C11 11.7167 10.9042 11.4792 10.7125 11.2875C10.5208 11.0958 10.2833 11 10 11C9.71667 11 9.47917 11.0958 9.2875 11.2875C9.09583 11.4792 9 11.7167 9 12C9 12.2833 9.09583 12.5208 9.2875 12.7125C9.47917 12.9042 9.71667 13 10 13ZM10 9C10.2833 9 10.5208 8.90417 10.7125 8.7125C10.9042 8.52083 11 8.28333 11 8C11 7.71667 10.9042 7.47917 10.7125 7.2875C10.5208 7.09583 10.2833 7 10 7C9.71667 7 9.47917 7.09583 9.2875 7.2875C9.09583 7.47917 9 7.71667 9 8C9 8.28333 9.09583 8.52083 9.2875 8.7125C9.47917 8.90417 9.71667 9 10 9ZM10 5C10.2833 5 10.5208 4.90417 10.7125 4.7125C10.9042 4.52083 11 4.28333 11 4C11 3.71667 10.9042 3.47917 10.7125 3.2875C10.5208 3.09583 10.2833 3 10 3C9.71667 3 9.47917 3.09583 9.2875 3.2875C9.09583 3.47917 9 3.71667 9 4C9 4.28333 9.09583 4.52083 9.2875 4.7125C9.47917 4.90417 9.71667 5 10 5ZM18 16H2C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V10C0.55 10 1.02083 9.80417 1.4125 9.4125C1.80417 9.02083 2 8.55 2 8C2 7.45 1.80417 6.97917 1.4125 6.5875C1.02083 6.19583 0.55 6 0 6V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V6C19.45 6 18.9792 6.19583 18.5875 6.5875C18.1958 6.97917 18 7.45 18 8C18 8.55 18.1958 9.02083 18.5875 9.4125C18.9792 9.80417 19.45 10 20 10V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16ZM18 14V11.45C17.3833 11.0833 16.8958 10.5958 16.5375 9.9875C16.1792 9.37917 16 8.71667 16 8C16 7.28333 16.1792 6.62083 16.5375 6.0125C16.8958 5.40417 17.3833 4.91667 18 4.55V2H2V4.55C2.61667 4.91667 3.10417 5.40417 3.4625 6.0125C3.82083 6.62083 4 7.28333 4 8C4 8.71667 3.82083 9.37917 3.4625 9.9875C3.10417 10.5958 2.61667 11.0833 2 11.45V14H18Z"
      fill="#1C1B1F"
    />
  </svg>
);

export const informationTooltipIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M6.33334 10.3333H7.66668V6.33333H6.33334V10.3333ZM7.00001 5C7.1889 5 7.34723 4.93611 7.47501 4.80833C7.60279 4.68055 7.66668 4.52222 7.66668 4.33333C7.66668 4.14444 7.60279 3.98611 7.47501 3.85833C7.34723 3.73056 7.1889 3.66667 7.00001 3.66667C6.81112 3.66667 6.65279 3.73056 6.52501 3.85833C6.39723 3.98611 6.33334 4.14444 6.33334 4.33333C6.33334 4.52222 6.39723 4.68055 6.52501 4.80833C6.65279 4.93611 6.81112 5 7.00001 5ZM7.00001 13.6667C6.07779 13.6667 5.21112 13.4917 4.40001 13.1417C3.5889 12.7917 2.88334 12.3167 2.28334 11.7167C1.68334 11.1167 1.20834 10.4111 0.858343 9.6C0.508343 8.78889 0.333344 7.92222 0.333344 7C0.333344 6.07778 0.508343 5.21111 0.858343 4.4C1.20834 3.58889 1.68334 2.88333 2.28334 2.28333C2.88334 1.68333 3.5889 1.20833 4.40001 0.858333C5.21112 0.508333 6.07779 0.333333 7.00001 0.333333C7.92223 0.333333 8.7889 0.508333 9.60001 0.858333C10.4111 1.20833 11.1167 1.68333 11.7167 2.28333C12.3167 2.88333 12.7917 3.58889 13.1417 4.4C13.4917 5.21111 13.6667 6.07778 13.6667 7C13.6667 7.92222 13.4917 8.78889 13.1417 9.6C12.7917 10.4111 12.3167 11.1167 11.7167 11.7167C11.1167 12.3167 10.4111 12.7917 9.60001 13.1417C8.7889 13.4917 7.92223 13.6667 7.00001 13.6667ZM7.00001 12.3333C8.4889 12.3333 9.75001 11.8167 10.7833 10.7833C11.8167 9.75 12.3333 8.48889 12.3333 7C12.3333 5.51111 11.8167 4.25 10.7833 3.21667C9.75001 2.18333 8.4889 1.66667 7.00001 1.66667C5.51112 1.66667 4.25001 2.18333 3.21668 3.21667C2.18334 4.25 1.66668 5.51111 1.66668 7C1.66668 8.48889 2.18334 9.75 3.21668 10.7833C4.25001 11.8167 5.51112 12.3333 7.00001 12.3333Z"
      fill="#B5B5B5"
    />
  </svg>
);
export const uploadLineIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0A0D14">
    <path d="M3 19H21V21H3V19ZM13 5.82843V17H11V5.82843L4.92893 11.8995L3.51472 10.4853L12 2L20.4853 10.4853L19.0711 11.8995L13 5.82843Z"></path>
  </svg>
);
export const deleteBinLineIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0A0D14">
    <path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"></path>
  </svg>
);

export const uploadCloudLineIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#525866">
    <path d="M12 12.5858L16.2426 16.8284L14.8284 18.2426L13 16.415V22H11V16.413L9.17157 18.2426L7.75736 16.8284L12 12.5858ZM12 2C15.5934 2 18.5544 4.70761 18.9541 8.19395C21.2858 8.83154 23 10.9656 23 13.5C23 16.3688 20.8036 18.7246 18.0006 18.9776L18.0009 16.9644C19.6966 16.7214 21 15.2629 21 13.5C21 11.567 19.433 10 17.5 10C17.2912 10 17.0867 10.0183 16.8887 10.054C16.9616 9.7142 17 9.36158 17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9C7 9.36158 7.03838 9.7142 7.11205 10.0533C6.91331 10.0183 6.70879 10 6.5 10C4.567 10 3 11.567 3 13.5C3 15.2003 4.21241 16.6174 5.81986 16.934L6.00005 16.9646L6.00039 18.9776C3.19696 18.7252 1 16.3692 1 13.5C1 10.9656 2.71424 8.83154 5.04648 8.19411C5.44561 4.70761 8.40661 2 12 2Z"></path>
  </svg>
);
export const hashtagIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#525866">
    <path d="M7.78428 14L8.2047 10H4V8H8.41491L8.94043 3H10.9514L10.4259 8H14.4149L14.9404 3H16.9514L16.4259 8H20V10H16.2157L15.7953 14H20V16H15.5851L15.0596 21H13.0486L13.5741 16H9.58509L9.05957 21H7.04855L7.57407 16H4V14H7.78428ZM9.7953 14H13.7843L14.2047 10H10.2157L9.7953 14Z"></path>
  </svg>
);
export const circleFilledIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"></path>
  </svg>
);
